﻿import { continuousVisualizer, currentVisualizer } from "./Visualizer";

let savedStart: any;
let savedStop: any;
let savedPause: any;
let canvas: any;
async function Start() {
    Stop();
    const audio = await navigator.mediaDevices.getUserMedia({
        video: false,
        audio: true,
    });
    canvas = document.getElementById("recording-indicator") as HTMLCanvasElement;
    //canvas.style.display = "block";
    const { start, stop, reset, pause } = continuousVisualizer(
        audio,
        canvas,
        {
            rectWidth: 3,
            strokeColor: "--mud-palette-text-primary",
            barRadius: 2
        }
    );
    savedStop = stop;
    savedStart = start;
    savedPause = pause;
    start();
};

function Stop() {
    if (savedStop != null) {
        savedStop();
        savedStop = null;
        savedStart = null;
        savedPause = null;
    }
    //if (canvas != null) canvas.style.display = "none";
}
function Pause() {
    if (savedPause != null) savedPause();
    //if (canvas != null) canvas.style.display = "none";
}
function Resume() {
    if (savedStart != null) savedStart();
    //if (canvas != null) canvas.style.display = "block";
}
export const RecordingIndicator = {
    Start,
    Stop,
    Pause,
    Resume
}